import { useQuery } from '@tanstack/react-query';
import { dashboardQueries } from '../api/dashboard-queries';
import type { DashboardParams } from './schema';

export function useDashboard(params?: DashboardParams) {
  return useQuery(dashboardQueries.summary(params));
}
